module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.2751ee4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Regular.woff2
// module id = 320
// module chunks = 1